import { normalizeName } from "services/utils";

const { Config } = require("services/Config");
const { sendRequest, get } = require("services/Helper");

class FileService {

  static getFileContent = async (game, limit) => {
    const fileUrl = Config.getPrivateFilesUrl(normalizeName(game), limit);
    const preSignedUrlJson = await get(fileUrl);
    if (!preSignedUrlJson?.url) {
      return Promise.reject("Can't get pre-signed URL for file: " + fileUrl);
    }
    return sendRequest(preSignedUrlJson.url, { method: "GET", credentials: "omit" });
  }

  static getPublicFileContent = async (filePath) => {
    const normalizedFilePath = typeof filePath === "string" ? filePath.trim() : "";
    if (!normalizedFilePath) {
      return Promise.reject(new Error("Public file path is required"));
    }

    const fileUrl = Config.getPublicFileUrl(normalizedFilePath);
    return sendRequest(fileUrl, { method: "GET", credentials: "omit" });
  };

}

export { FileService };
